__turbopack_context__.v({
  "alchemySymbol": "BjuXyq_alchemySymbol",
});
